import "./Loader.css";
import React from "react";

const Component = () => (
      <div className="Loader ">
            <div className="lds-blocks">
                  <div className="lds-blocks-1" />
                  <div className="lds-blocks-2" />
                  <div className="lds-blocks-3" />
                  <div className="lds-blocks-4" />
            </div>
      </div>
);

export default Component;
